import React from 'react'
import {useTranslation} from "react-i18next"
import {useSelector} from "react-redux"
import Itind_EN from "./Itind_EN";
import Itind_RU from "./Itind_RU";

const Itind = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)

    switch (language) {
        case 'EN':
            return (
                <Itind_EN/>
            )
        case 'RU':
            return (
                <Itind_RU/>
            )
        case 'BG':
            return (
                <Itind_EN/>
            )
        default:
            return (
                <Itind_EN/>
            )
    }
}

export default Itind


// WEBPACK FOOTER //
// ./src/Components/Itind/Itind.js